import Vue from "vue";

Vue.prototype.$allacciatura = [
  {
    key: "allacciatura0",
    variant: [
      { key: "allacciatura0var1" },
      { key: "allacciatura0var2" },
      { key: "allacciatura0var3" },
      { key: "allacciatura0var4" }
    ]
  },
  {
    key: "allacciatura1",
    variant: [
      { key: "allacciatura1var1" },
      { key: "allacciatura1var2" },
      { key: "allacciatura1var3" },
      { key: "allacciatura1var4" },
      { key: "allacciatura1var5" },
      { key: "allacciatura1var6" },
      { key: "allacciatura1var7" },
      { key: "allacciatura1var8" },
      // { key: "allacciatura1var9" }
    ]
  },
  {
    key: "allacciatura2",
    variant: [
      { key: "allacciatura2var1" },
      { key: "allacciatura2var2" },
      { key: "allacciatura2var3" },
      { key: "allacciatura2var4" }
    ]
  },
  {
    key: "allacciatura3",
    variant: []
  },
  {
    key: "allacciatura4",
    variant: [
      { key: "allacciatura4var1" },
      { key: "allacciatura4var2" },
      { key: "allacciatura4var3" },
      { key: "allacciatura4var4" }
    ]
  },
  {
    key: "allacciatura5",
    variant: []
  }
];
